import DepositFixedTermSettings from "@/models/Products/ProductSettings/DefaultSettings/FixedTerm/DepositFixedTermSettings";

export default class AccountDepositFixedTermSettings extends DepositFixedTermSettings {
    overridden: boolean = false;
}